"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = __importDefault(require("../../Icon"));
var Logo_1 = __importDefault(require("../../Logo"));
var hooks_1 = require("../hooks");
var styles_1 = require("./styles");
var MobileHeader = function (_a) {
    var logoPath = _a.logoPath, setSidebarState = _a.setSidebarState;
    var _b = (0, hooks_1.useSidebarState)(), isSidebarOpen = _b.isSidebarOpen, setIsSidebarOpen = _b.setIsSidebarOpen;
    var handleControlClick = function () {
        setIsSidebarOpen(!isSidebarOpen);
        setSidebarState(!isSidebarOpen);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(styles_1.LogoContainer, __assign({ to: logoPath }, { children: (0, jsx_runtime_1.jsx)(Logo_1.default, {}) })), (0, jsx_runtime_1.jsx)(styles_1.MenuControlContainer, __assign({ onClick: handleControlClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: isSidebarOpen ? 'close' : 'menu', size: "l" }) }))] }));
};
exports.default = MobileHeader;
